// List of valid private codes and their descriptions
export const VALID_PRIVATE_CODES = {
  LAUNCH500: "Launch promotion code - 500 credits",
  BETA500: "Beta tester reward code - 500 credits",
  PARTNER500: "Partner promotion code - 500 credits",
  DANIELMIESSLER: "Daniel Miessler - 500 credits",
} as const;

export type ValidPrivateCode = keyof typeof VALID_PRIVATE_CODES;

/**
 * Validates if a given code is a valid private code
 * @param code The code to validate
 * @returns true if the code is valid, false otherwise
 */
export function isValidPrivateCode(
  code: string | null
): code is ValidPrivateCode {
  if (!code) return false;
  return code in VALID_PRIVATE_CODES;
}

/**
 * Gets the description for a valid private code
 * @param code The code to get the description for
 * @returns The description if the code is valid, undefined otherwise
 */
export function getPrivateCodeDescription(code: string): string | undefined {
  return isValidPrivateCode(code) ? VALID_PRIVATE_CODES[code] : undefined;
}
